import { styled } from '@mui/material/styles';
import { Accordion, Divider } from '@mui/material';
import { DS_breakpoints as coreBreakpoints } from 'mui/base/theme/DS_Tokens/core';
import { renderTypographyStyles } from '../../../../../../base/utils';
import { ACCORDION_SUBMENU_HEIGHT_LG } from '../../constants/headerConstants';

export const StyledMenuLinks = styled('div')(
  ({ theme }) => `
     padding-bottom: ${theme.DS_spacing(['md'])} ;  
  
     ${theme.breakpoints.up('lg')} {
       display: flex;
       gap:  ${theme.DS_spacing(['md'])} ; 
       justify-content: center;
       padding-bottom: 0;  
       margin-top: -2px;
       margin-right: ${theme.DS_spacing(['md'])} ; 
     }     
  `,
);

export const StyledWrapperAccordion = styled('div')(
  ({ theme }) => `
  
    > .MuiAccordion-root {
     box-shadow: none !important;
     border: none;
     padding: ${theme.DS_spacing(['md'])} 0 ${theme.DS_spacing(['xxs'])};  
    }
    svg {
      fill: black;
      height: 10px !important;
      width: 10px !important;
      margin: 0 ${theme.DS_spacing(['xxs'])};
    }
  
    .MuiAccordionSummary-content > span {
        ${renderTypographyStyles(theme.typography.DS_labelSmallBold)};
        text-transform: uppercase;
       
    }
    
      ${theme.breakpoints.up('lg')} {
        > .MuiAccordion-root {
           max-width: min-content !important;
           padding: 10px 0 0;
           min-height: unset;
        }
      }

  `,
);

export const StyledListItem = styled('div')(
  ({ theme }) => `
   padding: ${theme.DS_spacing(['xs'])} 0;
   :first-of-type {
      margin-top: ${theme.DS_spacing(['xs'])};
   }
   :last-of-type {
      margin-bottom: ${theme.DS_spacing(['lg'])};
   }
    a {
      color: ${theme.DS_palette.text.primary};
        ${renderTypographyStyles(theme.typography.DS_labelSmallRegular)};
    }
 
  `,
);

export const StyledDirectLinks = styled('div')(
  ({ theme }) => `
     padding: ${theme.DS_spacing(['md'])} 0 0;  
     ${renderTypographyStyles(theme.typography.DS_labelSmallBold)};
     a {
       color: ${theme.DS_palette.text.primary};
       text-transform: uppercase;

     }
     hr {
       margin-top: ${theme.DS_spacing(['md'])}; 
     }
     ${theme.breakpoints.up('lg')} {
        padding-right: ${theme.DS_spacing(['xxs'])};  
        padding-left: ${theme.DS_spacing(['xxs'])};  
     }
       
  `,
);

export const StyledControlledAccordion = styled(Accordion)(
  ({ theme }) => `
  
      .MuiAccordionSummary-content{
        flex: 0;
         &:hover {
           color: ${theme.DS_palette.buttons.enabled};
         }
         > span {
            width: max-content;
         }
       }
   
       .Mui-expanded{
         color: ${theme.DS_palette.buttons.enabled};
       }
  
      .MuiCollapse-root {
         position: fixed;
         left: 0;
         width: 100%;
         padding-top: ${theme.DS_spacing(['sm'])};
         background-color: ${theme.DS_palette.primary.white};
         .MuiCollapse-wrapper {
           ${theme.breakpoints.up('xl')} {
            margin: 0 auto;
            max-width: ${coreBreakpoints['xl']}em;
          }
         }
  
       .MuiAccordionDetails-root{
         display: flex;
         height: ${ACCORDION_SUBMENU_HEIGHT_LG};
         gap: 60px;
        
         div {
           &:first-of-type{
            margin-top: 0;
            margin-left: ${theme.DS_spacing(['xlx'])};
           }
          list-style-type: none;
         }
      }
   }

  `,
);

export const StyledDivider = styled(Divider)(
  ({ theme }) => `
     ${theme.breakpoints.up('lg')} {
      display: none;
     }
  `,
);
